import { View, Text, Dimensions, SafeAreaView, Platform } from "react-native";
import React from "react";
import { height, tests, width } from "../../imports";
import { useDispatch, useSelector } from "react-redux";
import MyText from "../../components/custom/MyText";
import translate from "../../functions/translate";
import { Image } from "react-native";
import {
  femaleColor,
  gray,
  maleColor,
  orange,
  primary,
  white,
} from "../../colors";
import { useEffect } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import { LineChart } from "react-native-chart-kit";
import { useState } from "react";
import weightByAge from "../../api/test/growth/weightByAge";
import { ScrollView } from "react-native-gesture-handler";
import headByAge from "../../api/test/growth/headByAge";
import heightByAge from "../../api/test/growth/heightByAge";
import * as ScreenOrientation from "expo-screen-orientation";
import MyButton from "../../components/custom/MyButton";
import ChartShow from "./ChartShow";
import * as FileSystem from "expo-file-system";
import * as MediaLibrary from "expo-media-library";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import * as Linking from "expo-linking";

ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);

export default function GrowthTest({ route }) {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const [data, setData] = useState({ dataLable: [1] });
  const [childInfo, setChildInfo] = useState({});
  const [testInfo, setTestInfo] = useState({});
  const [fullScreenMode, setFullScreenMode] = useState(false);

  const datas = [
    null,
    null,
    null,
    10,
    null,
    null,
    null,
    12,
    null,
    null,
    null,
    11,
    null,
    null,
    null,
    15,
    14,
    null,
    null,
    12,
    null,
    null,
    null,
    null,
    null,
  ];
  const [deviceDimensions, setDeviceDimensions] = useState(
    Dimensions.get("window")
  );
  useEffect(() => {
    Dimensions.addEventListener("change", ({ window }) => {
      setDeviceDimensions(window);
    });
    if (fullScreenMode === true) {
      dispatch(hideBottomNavigation());
    } else {
      dispatch(showBottomNavigation());
    }
  }, [fullScreenMode]);

  const arrayCalculator = (array) => {
    const newArray = array;
    let startNumber = 0;
    let endNumber = 0;
    let startIndex = 0;
    let endIndex = 0;
    let currentStep = 0;
    let currentNumber = 0;
    const arrayLength = array.length;
    const numbersAvailable = array.filter((item) => item !== null).length;
    for (let j = 0; j < numbersAvailable; j++) {
      for (let i = 0; i < arrayLength; i++) {
        if (array[i] !== null && array[i + 1] === null) {
          startIndex = i;
          startNumber = array[i];
          currentNumber = array[i];
          break;
        }
      }
      for (let i = startIndex + 1; i < arrayLength; i++) {
        if (array[i] !== null) {
          endIndex = i;
          endNumber = array[i];
          currentStep = (endNumber - startNumber) / (endIndex - startIndex);
          break;
        }
      }
      for (let i = startIndex + 1; i < endIndex; i++) {
        newArray[i] = currentNumber + currentStep;
        currentNumber += currentStep;
      }
    }
    let sliceFrom = arrayLength;
    for (let i = 0; i < arrayLength; i++) {
      if (array[i] !== null && array[i + 1] === null) {
        sliceFrom = i + 1;
        break;
      }
    }
    return newArray.slice(0, sliceFrom);
  };
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#A7CA8D"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  useEffect(() => {
    if (route.params.testType === "WeightByAge") {
      weightByAge(route.params.childId)
        .then(({ data }) => {
          if (data.status === 200) {
            setData(data.image);
            setChildInfo(data.childDetail);
            setTestInfo(data.data.dataText);
          }
        })
        .catch((err) => {});
    } else if (route.params.testType === "HeightByAge") {
      heightByAge(route.params.childId)
        .then(({ data }) => {
          if (data.status === 200) {
            setData(data.image);
            setChildInfo(data.childDetail);
            setTestInfo(data.data.dataText);
          }
        })
        .catch((err) => {});
    } else if (route.params.testType === "HeadSizeByAge") {
      headByAge(route.params.childId)
        .then(({ data }) => {
          if (data.status === 200) {
            setData(data.image);
            setChildInfo(data.childDetail);
            setTestInfo(data.data.dataText);
          }
        })
        .catch((err) => {});
    }
  }, []);

  const downloadImage = async () => {
    if (Platform.OS !== "web") {
      try {
        const { uri } = await FileSystem.downloadAsync(
          data,
          `${FileSystem.documentDirectory}/${
            data.split("/")[data.split("/").length - 1]
          }`
        );
        const permission = await MediaLibrary.requestPermissionsAsync();
        if (permission.status === "granted") {
          await MediaLibrary.saveToLibraryAsync(uri).then(() => {
            Toast.show({
              type: "success",
              text1: "با موفقیت در گالری ذخیره شد",
            });
          });
        }
      } catch (err) {
        //console.log(err);
      }
    } else {
      fetch(data)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.download =
            data.split("/")[data.split("/").length - 1] || "asq-chart";
          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          //console.log(error);
        });
    }
  };
  return (
    <ScrollView style={{ flex: 1 }}>
      <View style={{ alignItems: "center", width: "100%" }}>
        <View
          style={{
            height: Dimensions.get("window").height,
            marginTop: -1 * Dimensions.get("window").height,
            backgroundColor: "#A7CA8D",
            width: "100%",
          }}
        ></View>
        <View style={{ alignItems: "center", width: "100%" }}>
          <View style={{ backgroundColor: "#A7CA8D", width: "100%" }}>
            <View
              style={{
                backgroundColor: "#A7CA8D",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                width: "100%",

                minHeight: 100,
                flexDirection: "row",
                paddingHorizontal: 10,
              }}
            >
              <View style={{ flex: 5 }}>
                <View>
                  <MyText
                    style={{
                      fontSize: 30,
                      marginTop: 10,
                      marginHorizontal: 10,
                      color: white,
                    }}
                  >
                    {translate("grow test")}
                  </MyText>
                </View>
                <View
                  direction={main.rtl ? "rtl" : "ltr"}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                ></View>
              </View>
              <View style={{ flex: 2 }}>
                <Image
                  source={tests}
                  style={{ width: "100%", height: 90 }}
                  resizeMode="contain"
                />
              </View>
            </View>
          </View>
        </View>
      </View>
      <View>
        {childInfo.name !== undefined && (
          <View style={{ padding: 5 }}>
            <MyText style={{ color: primary, fontSize: 18 }}>
              {`${main.rtl ? testInfo.chartNameFa : testInfo.chartNameEn}`}
            </MyText>
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                alignItems: "center",
              }}
            >
              <MyText
                style={{ color: gray }}
              >{`${childInfo.name} ${childInfo.lastName}`}</MyText>
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 10,
                alignItems: "center",
              }}
            >
              {/* <MyText style={{ color: gray }}>
                  {translate("your child age")}
                </MyText>
                {age.years > 0 && (
                  <MyText
                    style={{
                      marginHorizontal: 3,
                      color:
                        childInfo.gender === "boy" ? maleColor : femaleColor,
                    }}
                  >
                    {`${age.years} ${translate("year")}`}
                  </MyText>
                )}
                {age.months > 0 && (
                  <MyText style={{ color: gray }}>{`${
                    age.years > 0 ? translate("and") : ""
                  } ${age.months} ${translate("month")}`}</MyText>
                )} */}
            </View>
          </View>
        )}
      </View>
      <View>
        {childInfo.name !== undefined && (
          <ChartShow
            childId={route.params.childId}
            type={
              route.params.testType === "WeightByAge"
                ? "w"
                : route.params.testType === "HeightByAge"
                ? "hi"
                : "he"
            }
          />
        )}
      </View>
      <View>
        {childInfo.name !== undefined && (
          <View>
            {/*  <MyButton
            text="دریافت مشاوره"
            onPress={() => {
              if (childChatDetail.counselingId === undefined) {
                navigation.navigate("ConsultationNavigator", {
                  screen: "Consultation",
                  initial: false,
                  params: {
                    childId: childDetail.id,
                    childName: childDetail.name,
                    childImage: childDetail.image,
                    childGender: childDetail.gender,
                  },
                });
              } else {
                navigation.navigate("ConsultationNavigator", {
                  screen: "Chat",
                  initial: false,
                  params: {
                    childId: childDetail.id,
                    childName: childDetail.name,
                    childImage: childDetail.image,
                    childGender:
                      childDetail.gender === "boy" ? "male" : "female",
                    id: childChatDetail.counselingId,
                  },
                });
              }
            }}
          /> */}

            {/* <View style={{}}>
              <LineChart
                data={{
                  labels: data.dataLable.filter(
                    (item, index) =>
                      index % Math.ceil(data.dataLable?.length / 5) === 0
                  ),
                  datasets: [
                    {
                      data: data.Percentiles5,
                      withDots: false,
                      useShadowColorFromDataset: true,
                      fillShadowGradientFromOpacity: 0,
                      color: () => `rgba(220,20,60, 1)`,
                      strokeWidth: 1,
                    },
                    {
                      data: data.Percentiles25,
                      withDots: false,
                      useShadowColorFromDataset: true,
                      fillShadowGradientFromOpacity: 0,
                      color: () => `rgba(255,165,0, 1)`,
                      strokeWidth: 1,
                    },
                    {
                      data: data.Percentiles50,
                      withDots: false,
                      useShadowColorFromDataset: true,
                      color: (opacity, index) => `rgba(60, 220, 20, 1)`,
                      strokeWidth: 1,
                    },
                    {
                      data: data.Percentiles75,
                      withDots: false,
                      useShadowColorFromDataset: true,
                      color: (opacity, index) => `rgba(255,165,0, 1)`,
                      strokeWidth: 1,
                    },
                    {
                      data: data.Percentiles95,
                      withDots: false,
                      useShadowColorFromDataset: true,
                      color: (opacity, index) => `rgba(220,20,60, 1)`,
                      strokeWidth: 1,
                    },
                    {
                      data: arrayCalculator(data.person),

                      withDots: false,
                      useShadowColorFromDataset: true,
                      fillShadowGradientFromOpacity: 0,
                      color: (opacity, index) => `rgba(0, 0, 0, 1)`,
                      strokeWidth: 1,
                    },
                  ],
                }}
                width={
                  deviceDimensions.width > 500
                    ? deviceDimensions.width - 30
                    : deviceDimensions.width
                } // from react-native
                height={220}
                hideLegend={true}
                yAxisSuffix={testInfo.valueNameEn}
                yAxisInterval={5} // optional, defaults to 1
                // getDotColor={(dataPoint, dataPointIndex) => dataPoint !== null ? '#fefefe' : '#777'}
                chartConfig={{
                  propsForBackgroundLines: {
                    stroke: "#fff",
                  },
                  fillShadowGradientFrom: "#fff",
                  fillShadowGradientTo: "#fff",
                  backgroundColor: "#fff",
                  backgroundGradientFrom: "#fff",
                  backgroundGradientTo: "#fff",
                  // decimalPlaces: 1, // optional, defaults to 2dp
                  color: (opacity, index) =>
                    `rgba(255, 255, 255, ${index === 0 ? 1 : 0.4})`,
                  labelColor: () => `rgba(50, 50, 50, 1)`,
                  // style: {
                  //   borderRadius: 16,
                  //},
                }}
                bezier
                yLabelsOffset={Platform.OS === "web" ? 50 : 0}
                style={{
                  marginVertical: 8,
                  borderRadius: 16,
                }}
              />
            </View> */}

            {/* <View style={{ alignItems: "center" }}>
              <MyText>{`${
                main.rtl ? testInfo.ageTypeFa : testInfo.ageTypeEn
              }`}</MyText>
            </View> */}
            {/* <View style={{ width: "100%", padding: 5 }}>
              <MyText style={{ fontSize: 14, color: primary }}>
                {translate(
                  Platform.OS === "web" ? "rotate for full size chart" : ""
                )}
              </MyText>
              {Platform.OS !== "web" && (
                <MyButton
                  onPress={() => setFullScreenMode(true)}
                  text={translate("full size chart")}
                />
              )}
            </View> */}
            {/* <View style={{ alignItems: "center", marginTop: 20 }}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("your child")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(0, 0, 0, 1)",
                  }}
                ></View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("Percentiles5")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(220,20,60, 1)",
                  }}
                ></View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("Percentiles25")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(255,165,0, 1)",
                  }}
                ></View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("Percentiles50")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(60, 220, 20, 1)",
                  }}
                ></View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("Percentiles75")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(255,165,0, 1)",
                  }}
                ></View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 200,
                }}
              >
                <MyText>{translate("Percentiles95")}</MyText>
                <View style={{ flex: 1 }}></View>
                <View
                  style={{
                    marginHorizontal: 20,
                    width: 25,
                    height: 15,
                    borderRadius: 10,
                    backgroundColor: "rgba(220,20,60, 1)",
                  }}
                ></View>
              </View>
            </View> */}
          </View>
        )}
        <View style={{ padding: 5 }}>
          <MyButton
            style={{ backgroundColor: orange }}
            onPress={downloadImage}
            text={"دانلود تصویر چارت"}
          />
        </View>
      </View>
      <View style={{ height: 100 }}></View>
    </ScrollView>
  );
}
